<template>
  <div class="noticeDetails">
    <cus-title text="通知公告"></cus-title>
    <div class="notice-content">
      <div class="content-title">
        {{ detailsObj.noticeTitle }}
      </div>
      <div class="content-des">
        <span>发布时间：{{ parseTime(detailsObj.addTime) }}</span>
        <span>来源：{{ detailsObj.orgName }}</span>
      </div>
      <div class="noticeIntroduce">
      <div class="ql-editor"
           style="white-space: pre-wrap;"
           v-html="detailsObj.noticeIntroduce"></div>
    </div>
      <div class="fileList" v-if="detailsObj.attachFiles.length">
        <p style="font-size: 16px; font-weight: bold;">附件：</p>
        <ul>
          <li
            v-for="(item, index) in detailsObj.attachFiles"
            :key="index"
            @click="openFile(item)"
          >
            {{ index + 1 }}.{{ item.fileName }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { findNoticeDetail } from "@/api/notice";
import { getFileById } from "@/api/common";
import "@/views/notice/quill.core.css";
import '@/views/notice/quill.snow.css';
import '@/views/notice/quill.bubble.css';
export default {
  data() {
    return {
      detailsObj: {
        title: "sdad",
      },
      keyId: "",
    };
  },
  mounted() {
    this.keyId = this.$route.query.keyId;
    this.findNoticeDetail();
  },
  methods: {
    async findNoticeDetail() {
      const res = await findNoticeDetail({
        keyId: this.keyId,
      });
      this.detailsObj = res.data.detail;
    },
    openFile(item) {
      this.getFileById(item);
    },
    async getFileById(item) {
      const res = await getFileById({
        fileId: item.fileId,
        moduleFlag: "notice",
        downFlag:1,
      });
      const type = item.fileName.substring(item.fileName.lastIndexOf(".") + 1);
      const src =
          "data:application/"+type+";base64," +
          btoa(
            new Uint8Array(res.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      let eleLink = document.createElement("a");
      eleLink.download = item.fileName;
      eleLink.style.display = "none";
      eleLink.href = src
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
  },
};
</script>

<style lang="less" scoped>
.noticeDetails {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  background: #fff;
  .notice-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    > p {
      margin: 13px 0;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #55a6cb;
      line-height: 21px;
    }
    .content-title {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      line-height: 21px;
      margin-top: 20px;
      line-height: 30px;
    }
    .content-des {
      margin-top: 20px;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #6a6a6a;
      line-height: 21px;
      > span {
        margin: 0 10px;
      }
    }
    .noticeIntroduce {
      margin-top: 20px;
      padding: 20px 50px;
      border-top: 3px solid #e7e7e7;
      .ql-editor {
      width: 100%;
      margin-right: 200px;
    }
    }
    .fileList {
      width: 79%;
      margin-top: 35px;
      p {
        margin-bottom: 13px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #6a6a6a;
        line-height: 21px;
      }
      > ul {
        display: flex;
        flex-wrap: wrap;
        padding: 20px 50px;
        /*border: 1px solid #000;*/
        > li {
          margin-right: 50px;
          margin-bottom: 20px;
          cursor: pointer;
          color: #55a6cb;
        }
      }
    }
  }
}
</style>

<style>
.ql-editor.ql-indent-1  {
  text-indent: 10em;
}
</style>


// WEBPACK FOOTER //
// src/views/notice/noticeDetails.vue